<div class="flex flex-wrap gap-2">
  @for (slot of slots(); track slot.index) {
    @if (selectable()) {
      <button
        type="button"
        class="relative w-8 h-8 shrink-0 cursor-pointer"
        [class.ring-2]="selectedSlotIndex() === slot.index"
        [class.ring-base-content]="selectedSlotIndex() === slot.index"
        [attr.data-slot-index]="slot.index"
        [tp]="slotTooltip"
        [tpPlacement]="'top'"
        (click)="slotClick.emit(slot.index)"
        appSfx="ui-click"
        [sfxTrigger]="['click', 'hover']"
      >
        <div class="zoom-row">
          <app-slot-icon-blank>
            @if (slot.content) {
              <app-atlas-image
                spritesheet="item"
                [assetName]="slot.content.sprite"
              />
            }
          </app-slot-icon-blank>
        </div>
      </button>
    } @else {
      <div
        class="relative w-8 h-8 shrink-0"
        [tp]="slotTooltip"
        [tpPlacement]="'top'"
      >
        <div class="zoom-row">
          <app-slot-icon-blank>
            @if (slot.content) {
              <app-atlas-image
                spritesheet="item"
                [assetName]="slot.content.sprite"
              />
            }
          </app-slot-icon-blank>
        </div>
      </div>
    }

    <ng-template #slotTooltip>
      @if (slot.content) {
        <div class="p-2">
          <div class="type-entity-name mb-1 text-{{ slot.content.rarity }}">
            {{ slot.content.name }}
          </div>
          @if (isInfusable(slot.content)) {
            <app-row-stat-summary
              [stats]="slot.content.infusionStats!"
              [resistances]="slot.content.infusionDebuffResistances"
              [combatStats]="slot.content.infusionCombatStats"
            />
          }
        </div>
      } @else {
        <div class="p-2 type-flavor">Empty infusion slot</div>
      }
    </ng-template>
  }
</div>
